import { Grid2, Typography } from "@mui/material";
import Breadcrumbs from "../../../../../components/Breadcrumbs";
import { useTranslate } from "../../../../../hooks/useTranslate";
import { useStudents } from "../../../../../context/students";
import { HistoricalAbsencesTable } from "../../components/HistoricalAbsencesTable";
import "./HistoricalAbsences.css";
import React, { useState } from "react";
import { hasPermission, PERMISSIONS } from "../../../../../constants/permissions";
import LockedPage from "../../../../../components/LockedPage";

export const HistoricalAbsences = () => {
    const { t } = useTranslate();
    const { activeStudentId, activeStudent, permissions } = useStudents();

    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const showHistoricalAbsences = hasPermission(permissions, PERMISSIONS.ATTENDANCE_MANAGE);

    return (
        <div className="page-content">
            <div className="student-head-section"/>
            <Grid2 container spacing={2} className={showHistoricalAbsences ? "min-head-section-height--small" : "min-head-section-height"}>
                <Grid2 size={{ xs: 12, md: 7, lg: 8 }} className="text-white">
                    <Breadcrumbs
                        breadcrumbs={[
                            { label: t("navigation.home"), href: `/home/${activeStudentId}` },
                            { label: t("academic.title"), href: `/academic/${activeStudentId}` },
                            { label: t("academic.historicalAbsences"), current: true },
                        ]}
                    />
                    <Typography variant="h1" className="text-white">
                        {t("historicalAbsences.title")}
                    </Typography>
                    <Typography variant="body1" className="mt-4 text-white" component="div">
                        {t("historicalAbsences.subtitle", { name: activeStudent.fullName })}
                    </Typography>
                </Grid2>
            </Grid2>
            <div className="relative mt-4 z-1">
                <LockedPage showPermissionText isLocked={!showHistoricalAbsences}>
                    <Typography variant="h3" components="div" className="text-white">
                        {t("historicalAbsences.titleWithName", { name: activeStudent.fullName })}
                    </Typography>
                    {showSuccessMessage && (
                        <Typography variant="body1" component="div" className="mt-4 message-success-light">
                            {t("historicalAbsences.successSubmitting")}
                        </Typography>
                    )}
                    <HistoricalAbsencesTable
                        activeStudentId={activeStudentId}
                        name={activeStudent.fullName}
                        setShowSuccessMessage={setShowSuccessMessage}
                    />
                </LockedPage>
            </div>
        </div>
    );
};
